import React, { useEffect,useState } from 'react'
import { connect } from 'react-redux';
import { 
  Nav, 
  NavItem, 
  NavLink, 
  TabContent, 
  TabPane, 
  FormGroup, 
  Label, 
  Row
} from "reactstrap";

import {changePassword, updateProfile, logout} from '../../redux/actions';
//import Regex from "../utilities/regex";
// import { getById } from "../firebase/methods";
import { updatePassword,getById } from "../../firebase/methods";
import { storage } from "../../firebase";
import bcrypt from "bcryptjs";
import { toast } from "react-toastify";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { useDispatch,useSelector } from "react-redux";

const Settings = (props) => {

  
  const dispatch = useDispatch();
   const [ image ,setimage]=useState(""); 
   const [ cropper ,setcropper]=useState(""); 
   const [ cropData ,setcropData]=useState("");
   const [ previewImage ,setpreviewImage]=useState("");
   const [ userprofileimage ,setuserprofileimage]=useState(""); 
   const [  user,setuser]=useState(null); 
   const [ activeTab ,setactiveTab]=useState("1"); 
   const [ oldPassword ,setoldPassword]=useState("");  
   const [ newPassword ,setnewPassword]=useState("");  
   const [  confirmPassword,setconfirmPassword]=useState(""); 
   const [ showPassword ,setshowPassword]=useState(false);   
   const [ showPassword1 ,setshowPassword1]=useState(false); 
   const [ showPassword2 ,setshowPassword2]=useState(false); 
   const [ errors ,seterrors]=useState({confirmPassword: false, newPassword: false, oldPassword: false, });  
  

   const userDetails = useSelector((state) => state.userDetails.user);








//  const onHandleChange = ({ target: { name, value } }) => {
//     seterrors({ ...errors,[name]: false,})
//     // this.setState({errors: { ...errors,[name]: false,},     [name]: value,  });
//   };

 const changePassword = async(request) => {
    try{
        const user = await getById("users", userDetails.uid);
        const isPasswordMatching = await bcrypt.compare(    request.oldPassword, user.password );
        if (!isPasswordMatching) {
          toast.error("Invalid old password");
        } else {
          await updatePassword(request.newPassword);
          logout();
          toast.success("Password updated successfully");
        }
        
      }catch(error){
        console.log(error);
        toast.error(error.message);
      }
  };

 const handleFireBaseUpload = async () => {
    try{
      const fileName = `${Date.now()}`;
      const imagePath = `/images/listing/${fileName}`;
      await storage.ref(imagePath).putString(  previewImage, 'data_url', {contentType:'image/jpg'} );
      let imageUrl = await storage.ref("images/listing").child(fileName).getDownloadURL();
      return{ imagePath: imagePath,imageUrl: imageUrl  }
    }catch(error){
      console.log(error);
      toast.error(error.message);
    }
   
  }

 const getUserDetail = async()=>{
    const user = await getById("users", userDetails.uid);
    setuser(user)
   }

 const updateProfile = async(request) => {
      if(previewImage){
        let imagedata= await handleFireBaseUpload();
        request = {...request};
        request.profile_image = imagedata.imageUrl;
      }
      await dispatch(updateProfile({data:request}));
      setpreviewImage("")
      getUserDetail();
  }

 

 const  fileSelectHandler = (e) => {
        e.preventDefault();
        let files;
        if (e.dataTransfer) {
          files = e.dataTransfer.files;
        } else if (e.target) {
          files = e.target.files;
        }
        const reader = new FileReader();
        reader.onload = () => {
          setimage(reader.result)

        };
        reader.readAsDataURL(files[0]);
    }

  const  getCropData = () => {
        if (typeof cropper !== "undefined") {
          cropper.getCroppedCanvas().toBlob((blob) => {
            const url = URL.createObjectURL(blob);
            blob.name = 'photo.jpeg'; //eslint-disable-line
            setcropData(blob);
            setimage("")
            setpreviewImage(cropper.getCroppedCanvas().toDataURL())
            URL.revokeObjectURL(url);
          }, 'image/jpeg');
        }
    }

  const  removeImage = async() =>{
        // var r = confirm("Are you sure you want to delete?");
        // if(r){
        //   let pictureRef = await storage.refFromURL(profile_image);
        //   let self = this;
        //   pictureRef.delete().then(async() => {
        //       let data = {
        //         firstName:self.state.user.firstName,
        //         lastName:self.state.user.lastName,
        //         email:self.state.user.email,
        //         phone:self.state.user.phone,
        //         address:self.state.user.address,
        //         city:self.state.user.city,
        //         country:self.state.user.country,
        //         postalcode:self.state.user.postalcode,
        //         profile_image:""
        //       }
        //       await updateProfile({data:data});
        //       getUserDetail();
        //   })
        // }  
    }

  const  removeProfileImage = async() => {
       setpreviewImage("")
    }

  // componentDidMount(){
  //     this.getUserDetail();
  // }

// useEffect(()=>{
//   getUserDetail();
// },[])

  return (
    <>
      {/* <div className="dashContentHeader">
        <h5 className="dashHeading mb-0">My Account</h5>
      </div>


      <div className="dashboardCardRow pb-3">
        <div className="col-xl-6 col-lg-10 p-0">  <h3 style={{ color: '#ff7e06' }}>Change Password</h3>
          <hr /></div>
        <form className="mg-login admin-pass mt-5 col-xl-6 col-lg-10 p-4 bg-white">
          <h2 className="dashheader-title mb-4">Password Settings</h2>
          <div className="row">

            <div className="col-md-6 mb-4"><label>Current Password</label>{" "}<span style={{ color: '#ff7e06' }}>*</span>
              <input type="text" className="form-control" id="" placeholder="Old password" />
            </div>
            <div className="col-md-6 mb-4 "><label>new password</label>{" "}<span style={{ color: '#ff7e06' }}>*</span>
              <input type="text" className="form-control" id="" placeholder="New password" />
            </div>

            <div className="col-md-6 mb-3"><label>Confirm new password</label>{" "}<span style={{ color: '#ff7e06' }}>*</span>
              <input type="text" className="form-control" id="" placeholder="Confirm new password" />
            </div>

          </div>
          <button className=" sub-button py-3">Save Changes</button>
        </form>
      </div> */}


<div className="dashboardCardRow">
          <div className="row border-radius-4 box  setting-mobile ">
            <div className=" col-lg-10 px-0"  style={{"marginLeft":"0px"}}>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={activeTab == "1" ? "active" : ""}
                    onClick={() => setactiveTab("1")}
                  >
                    Settings
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={activeTab == "2" ? "active" : ""}
                    onClick={() => setactiveTab("2")}
                  >
                    Change Password
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent
                activeTab={activeTab}
                className="tab-content bg-white p-4 mt-4"
              >
                <TabPane tabId="1">
                  <div
                    role="tabpanel"
                    className="tab-pane fade in active show"
                    id="Settings"
                  >
                    <h2 className="dashheader-title mb-4">Account Settings</h2>
                    <div className="inner-form">
                      <div className="image-info d-flex py-4 ">

                        <div className="mr-5">
                            {!image?( <img src={previewImage  ?previewImage:user && user.profile_image?
                                  user.profile_image:"../static/images/profile-info.png"
                                 } className="img-max-width " alt="" />
                            ):null}
                            {image?(
                                  <Cropper
                                  style={{ height: 195, width: "100%" }}
                                  initialAspectRatio={1}
                                  preview=".img-preview"
                                  src={image}
                                  viewMode={1}
                                  guides={true}
                                  minCropBoxHeight={10}
                                  minCropBoxWidth={10}
                                  background={false}
                                  responsive={true}
                                  autoCropArea={1}
                                  checkOrientation={false} 
                                  onInitialized={(instance) => {
                                    setcropper(instance)
                                  
                                  }}
                                />
                              ):null}
                        </div>
                        {image?(<div className="d-flex align-items-center">
                           {" "}
                           <button onClick={()=>{getCropData()}} className="btn upload mr-4">Crop</button>
                           <button onClick={()=>{setimage("")}} className="btn remove">Cancel</button>
                        </div>):null}
                        {!image?(<div className="d-flex align-items-center">
                          {" "}
                          <button onClick={()=>{document.getElementById("selectImage").click()}} className="btn upload mr-4">Upload</button>
                          <input id='selectImage' hidden type="file" onChange={(e)=>{fileSelectHandler(e)}} />
                        </div>):null}
                        {(user && user.profile_image || previewImage)?(<div className="d-flex align-items-center">
                           {user && user.profile_image && <button onClick={()=>{removeImage()}} class="btn remove">Remove</button>}
                           {previewImage && <button onClick={()=>{removeProfileImage()}} class="btn remove">Remove</button>}
                        </div>):null}
                      </div>
                      <hr />
                      <Formik
                          enableReinitialize={true}
                          initialValues={{
                              firstName:user && user.firstName?user.firstName:"",
                              lastName:user && user.lastName?user.lastName:"",
                              email:user && user.email?user.email:"",
                              phone:user && user.phone?user.phone:"",
                              address:user && user.address?user.address:"",
                              city:user && user.city?user.city:"",
                              country:user && user.country?user.country:"",
                              postalcode:user && user.postalcode?user.postalcode:""
                          }}
                          validationSchema={Yup.object({

                            firstName: Yup.string()
                            .min(2, 'Invalid First name')
                            .required('First name is required')
                            .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field"),

                            lastName: Yup.string()
                            .min(2, 'Invalid Last name')
                            .required('Last name is required')
                            .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field"),

                            email: Yup.string()
                              .email('Invalid email address')
                              .required('Email is required'),

                            phone: Yup.string().matches(
                              /^([0-9\(\)\/\+ \-]*)$/, 
                              'Phone number is not valid, only number allowed'),

                            address: Yup.string()
                            .required('Address is required'),

                            city: Yup.string()
                              .required('New email is required'),

                            country: Yup.string()
                              .required('Country is required'),

                            postalcode: Yup.string()
                            .required('Postal code is required')
                          })}
                          onSubmit={(values, { setSubmitting }) => {
                            updateProfile(values);
                            setSubmitting(false);
                          }}
                        >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                        }) => (
                          <Form
                             onSubmit={handleSubmit}
                             id="email-edit"
                             className="mg-login mt-5"
                           >
                               <div className="row">
                                  <div className="col-md-6 mb-4">
                                    <label>First name</label>
                                    <input
                                      value={values.firstName}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="firstName"
                                      type="text"
                                      className="form-control"
                                      id
                                      placeholder="Marcus"
                                    />
                                    {errors.firstName && touched.firstName &&<p className="error">{errors.firstName}</p> }
                                  </div>
                                  <div className="col-md-6 mb-4 ">
                                    <label>Last name</label>
                                    <input
                                      value={values.lastName}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="lastName"
                                      type="text"
                                      className="form-control"
                                      id
                                      placeholder="Atkins"
                                    />
                                    {errors.lastName && touched.lastName &&<p className="error">{errors.lastName}</p> }
                                  </div>
                                  <div className="col-md-6 mb-4">
                                    <label>email address</label>
                                    <input
                                      value={values.email}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="email"
                                      type="text"
                                      className="form-control"
                                      id
                                      placeholder="Marcus@domain.com"
                                    />
                                    {errors.email && touched.email &&<p className="error">{errors.email}</p> }
                                  </div>
                                  <div className="col-md-6 mb-4 ">
                                    <label>phone number</label>
                                    <input
                                      value={values.phone}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="phone"
                                      type="text"
                                      className="form-control"
                                      id
                                      placeholder="+13 6 12 34 56 78"
                                    />
                                    {errors.phone && touched.phone &&<p className="error">{errors.phone}</p> }
                                  </div>
                                  <div className="col-md-6 mb-4">
                                    <label>address</label>
                                    <input
                                      value={values.address}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      name="address"
                                      type="text"
                                      className="form-control"
                                      id
                                      placeholder="751 Green Hill Dr. Webster, NY 14580"
                                    />
                                    {errors.address && touched.address &&<p className="error">{errors.address}</p> }
                                  </div>
                                  <div className="col-md-6 mb-4 ">
                                    <label>city</label>
                                    <select 
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="city"
                                    value={
                                      values.city
                                    } id="inputState" className="form-control">
                                      <option value="">Select City</option>
                                      <option value="Los Angeles">Los Angeles</option>
                                    </select>
                                    {errors.city && touched.city &&<p className="error">{errors.city}</p> }
                                  </div>
                                  <div className="col-md-6 mb-4">
                                    <label>country</label>
                                    <select
                                     onChange={handleChange}
                                     onBlur={handleBlur}
                                    name="country" 
                                    value={
                                      values.country
                                    }
                                    id="inputState" className="form-control">
                                      <option value="">Select Country</option>
                                      <option value="United States">United States</option>
                                    </select>
                                    {errors.country && touched.country &&<p className="error">{errors.country}</p> }
                                  </div>
                                  <div className="col-md-6 mb-4 ">
                                    <label>postal code</label>
                                    <input
                                       onChange={handleChange}
                                       onBlur={handleBlur}
                                       value={
                                        values.postalcode
                                      }
                                      type="text"
                                      name="postalcode"
                                      className="form-control"
                                      id
                                      placeholder={10018}
                                    />
                                    {errors.postalcode && touched.postalcode &&<p className="error">{errors.postalcode}</p> }
                                  </div>
                                  <button  disabled={isSubmitting} type="submit" className="mx-3 sub-button mt-4">
                                    Save Changes
                                  </button>
                                </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </TabPane>
                <TabPane tabId="2">
                  <div
                    role="tabpanel"
                    className="tab-pane "
                    id="Change-Password"
                  >
                    <h2 className="dashheader-title mb-4">Password Settings</h2>
                    <Formik
                          initialValues={{
                              oldPassword:"",
                              newPassword:"",
                              confirmPassword:""
                          }}
                          validationSchema={
                            Yup.object({
                            oldPassword: Yup.string()
                            .required('Password is required')
                            .matches(
                              "^(?=.*[a-zA-Z0-9]).{8,}$",
                              "Please enter a valid password with 08-16 characters long and should be alphanumeric."
                            ),
                            newPassword: Yup.string()
                              .required('New password is required')
                              .matches(
                                "^(?=.*[a-zA-Z0-9]).{8,}$",
                                "Please enter a valid password with 08-16 characters long and should be alphanumeric."
                              ),
                            confirmPassword: Yup.string()
                              .required('Please confirm your password')
                              .matches(
                                "^(?=.*[a-zA-Z0-9]).{8,}$",
                                "Please enter a valid password with 08-16 characters long and should be alphanumeric."
                              )
                              .when("newPassword", {
                                is: val => (val && val.length > 0 ? true : false),
                                then: Yup.string().oneOf(
                                  [Yup.ref("newPassword")],
                                  "Password doesn't match"
                                )
                              })
                          })}
                          onSubmit={(values, { setSubmitting }) => {
                            changePassword(values);
                            setSubmitting(false);
                          }}
                        >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                        }) => (
                          <Form
                             onSubmit={handleSubmit}
                             id="email-edit"
                             className="mg-login mt-5"
                           >
                                 <Row>
                              <div className="col-md-6 mb-4">
                                  <FormGroup>
                                      <Label htmlFor="oldPassword">Current Password <span className="astrik">*</span></Label>
                                        <input
                                          name="oldPassword"
                                          className="form-control"
                                          placeholder="Old password"
                                          type={showPassword ? "type" : "password"}
                                          value={values.oldPassword}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                        />
                                        <a
                                          className="pwd-show"
                                          onClick={() => setshowPassword(!showPassword)
 
                                          }
                                          style={{ cursor: "pointer", top:"41px" }}
                                        >
                                          {showPassword ? "Hide" : "Show"}
                                        </a>
                                        {errors.oldPassword && touched.oldPassword && <p className="error">{errors.oldPassword}</p>}
                                  </FormGroup>
                              </div>
                              <div className="col-md-6 mb-4">
                                   <Label htmlFor="newPassword">New Password <span className="astrik">*</span></Label>
                                   <input
                                      name="newPassword"
                                      className="form-control"
                                      placeholder="New password"
                                      type={showPassword1 ? "type" : "password"}
                                      value={values.newPassword}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                     <a
                                          className="pwd-show"
                                          onClick={() =>
                                            setshowPassword1(!showPassword1)

                                          }
                                          style={{ cursor: "pointer", top:"41px" }}
                                        >
                                        {showPassword1 ? "Hide" : "Show"}
                                    </a>
                                   {errors.newPassword && touched.newPassword && <p className="error">{errors.newPassword}</p>}
                              </div> 
                              <div className="col-md-6 mb-4">
                                   <Label htmlFor="confirmPassword" className="email">
                                         Confirm New Password <span  className="astrik">*</span>
                                    </Label>
                                    <input
                                        name="confirmPassword"
                                        className="form-control"
                                        placeholder="Confrim password"
                                        type={showPassword2 ? "type" : "password"}
                                        value={values.confirmPassword}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                      <a
                                          className="pwd-show"
                                          onClick={() =>
                                            setshowPassword2(!showPassword2)

                                          }
                                          style={{ cursor: "pointer", top:"41px" }}
                                        >
                                        {showPassword2 ? "Hide" : "Show"}
                                       </a>
                                      {errors.confirmPassword && touched.confirmPassword && <p className="error">{errors.confirmPassword}</p>}
                              </div>
                          </Row>
                          <button disabled={isSubmitting} className=" sub-button" type="submit">
                              Save Changes
                            </button>
                          </Form>
                        )}
                      </Formik>
                  </div>
                </TabPane>
              </TabContent>
            </div>
          </div>
        </div>




















    </>
  )
}

export default Settings
